export default __webpack_public_path__ + "static/media/paperos-investors.962ba0ab.png";